// @flow
import React from 'react';
import type { Categories } from 'store/modules/banners';
import BannerLikeButton from 'components/banner/BannerLikeButton';
import { fromNow } from 'lib/common';
import BannerActionButtons from '../BannerActionButtons';
import './BannerHead.scss';
import BannerMobileShare from '../BannerMobileShare/BannerMobileShare';

type Props = {
  id: string,
  title: string,
  categories: Categories,
  user: {
    username: string,
    id: string,
    thumbnail: ?string,
    short_bio: ?string,
  },
  likes: number,
  liked: boolean,
  ownBanner: boolean,
  onToggleLike: () => void,
  onAskRemove: () => void,
  date: string,
  logged: boolean,
  url: string,
  isPrivate: boolean,
  informCopy: () => void,
};

const BannerHead = ({
  id,
  title,
  date,
  categories,
  user,
  likes,
  liked,
  ownBanner,
  onToggleLike,
  onAskRemove,
  logged,
  isPrivate,
  url,
  informCopy,
}: Props) => {
  return (
    <div className="BannerHead">
      <h1>{title}</h1>
      <div className="date-and-likes">
        <div className="date">{fromNow(date)}</div>
        <div className="placeholder" />
        <BannerMobileShare
          url={url}
          title={title}
          username={user.username}
          informCopy={informCopy}
        />
        <BannerLikeButton onClick={onToggleLike} liked={liked} likes={likes} disabled={!logged} />
      </div>
      <div className="separator" />
      {ownBanner && <BannerActionButtons id={id} onAskRemove={onAskRemove} />}
    </div>
  );
};

BannerHead.Placeholder = () => (
  <div className="BannerHead placeholder">
    <div className="gray-block _title" />
    <div className="date-and-likes">
      <div className="date">
        <div className="gray-block _date" />
      </div>
      <div className="placeholder" />
    </div>
    <div className="separator" />
  </div>
);
export default BannerHead;



// WEBPACK FOOTER //
// ./src/components/banner/BannerHead/BannerHead.js